<template>
  <div></div>
</template>

<script>
export default {
  name: 'Adcell',
  computed: {},
  data() {
    return {
      unsubscribe: function() {},
    }
  },
  watch: {
    $route() {
      this.$adcell.rerunScript()
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === '$_checkout/ORDER_CLOSED') {
        await this.$adcell.setConversionTag(state.cart.id, state.cart.token)
        this.$store.dispatch('clearCart')
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {},
}
</script>
